var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoCheckMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50008 0.416748C3.59433 0.416748 0.416748 3.59433 0.416748 7.50008C0.416748 11.4058 3.59433 14.5834 7.50008 14.5834C11.4058 14.5834 14.5834 11.4058 14.5834 7.50008C14.5834 6.7025 14.4446 5.93764 14.2002 5.22152L13.0533 6.36841C13.1277 6.73391 13.1667 7.11262 13.1667 7.50008C13.1667 10.6245 10.6245 13.1667 7.50008 13.1667C4.37562 13.1667 1.83341 10.6245 1.83341 7.50008C1.83341 4.37562 4.37562 1.83341 7.50008 1.83341C8.65679 1.83341 9.73269 2.18325 10.6309 2.78109L11.6449 1.76701C10.4776 0.921259 9.04779 0.416748 7.50008 0.416748ZM14.0826 1.3326L6.79175 8.62346L4.45923 6.29093L3.4576 7.29256L6.79175 10.6267L15.0842 2.33423L14.0826 1.3326Z",
    fill: "#2C62F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCheckMark);
export default __webpack_public_path__ + "static/media/ico_check_mark.7e077b87d862eb4cbfe3d4def3bd9b77.svg";
export { ForwardRef as ReactComponent };